// These are routes shared between SSR and SPA
export { processNavigationParams } from '../src/routes/processNavigationParams.tsx';
export { getSpaceOverviewRoute } from '../src/routes/SpaceOverviewRoute.tsx';
export { getCompanyHubRoute } from '../src/routes/company-hub/CompanyHubRoute.tsx';
export { getCompanyHubEditRoute } from '../src/routes/company-hub/CompanyHubEditRoute.tsx';
export { getCompanyHubEditorRoute } from '../src/routes/company-hub/CompanyHubEditorRoute.tsx';
export { getAccessLinkRoute } from '../src/routes/AccessLinkRoute.tsx';
export type { RouteWithNavParamsType } from '../src/routes/RouteType.ts';
